import { createContext, useContext } from "react";
import { theme } from "@clearabee/ui-library-native";
import type { StepPosition, TrainContextState } from "./Train.types";

export const TrainContext = createContext({} as TrainContextState);
export const useTrainContext = () => useContext(TrainContext);

export const getGradientColors = (
  active: boolean,
  complete: boolean,
  nextActive: boolean,
): string[] => {
  if (active) {
    return [
      theme.colors.positive.base,
      theme.colors.greyscale.lightest,
      theme.colors.greyscale.lightest,
    ];
  }

  if (nextActive) {
    return [theme.colors.positive.lighter, theme.colors.positive.base];
  }

  if (complete) {
    return [theme.colors.positive.lighter, theme.colors.positive.lighter];
  }

  return [theme.colors.greyscale.lightest, theme.colors.greyscale.lightest];
};

export const calculateStepPosition = (
  step: number,
  currentStep: number,
  numberOfSteps: number,
): StepPosition => {
  return {
    complete: step < currentStep,
    active: step === currentStep,
    first: step === 0,
    last: step === numberOfSteps - 1,
  };
};
